import { TROUBLESHOOTING } from "./constants_v2.js";

/**
 * Front-end console logging is for dev work only. When TROUBLESHOOTING is
 * false, every console method below becomes a no-op, so nothing the app (or a
 * library it uses) logs reaches the browser console. app_v2.js imports this
 * module first, so it runs before any other module's code.
 *
 * `alwaysLog` is the one exception: it always prints (the build number line).
 * Uncaught errors still appear, because the browser reports those itself.
 */
const originalLog = console.log.bind(console);

if (!TROUBLESHOOTING) {
  const silent = () => {};
  for (const method of ["log", "info", "debug", "warn", "error", "trace", "table", "dir", "group", "groupCollapsed", "groupEnd"]) {
    console[method] = silent;
  }
}

export const alwaysLog = (...args) => originalLog(...args);
